import { useMemo } from 'react';
import useFetch from 'framework-asset-preview-lib/internal/shared/hooks/useFetch';
import { fetchAssociationsFromOtherSources } from 'framework-asset-preview-lib/internal/shared/api/associations';
export default function useFetchAssociationsFromOtherSources({
  crmObject,
  crmObjectTypeDefinitionsForPortal,
  nonCrmObject
}) {
  const fetchAssociationsFromOtherSourcesProps = useMemo(() => ({
    fetcher: () => fetchAssociationsFromOtherSources({
      crmObject,
      crmObjectTypeDefinitionsForPortal: crmObjectTypeDefinitionsForPortal || [],
      nonCrmObject
    }),
    skip: Boolean(!crmObjectTypeDefinitionsForPortal || crmObjectTypeDefinitionsForPortal.length === 0)
  }), [crmObject, crmObjectTypeDefinitionsForPortal, nonCrmObject]);
  return useFetch(fetchAssociationsFromOtherSourcesProps);
}